import React, { useContext, useEffect, useState } from "react";
import About1 from "../../assets/images/about1.png";
import About2 from "../../assets/images/about2.png";
import Trishul from "../../assets/images/trishul.png";
import Icon from "../../assets/images/omnamo/icon.png";
import supportImg2 from "../../assets/images/shapes/arrow-1.png";
import "bootstrap/dist/css/bootstrap.min.css";
// import { Link } from "react-router-dom";
import bg from "../../assets/images/new/main-bg.png";
import Batuk from "../../assets/images/new/fav-removebg-preview.png";
import prasadBooking from "../../assets/images/new/prasad-booking.png";
import {
  FaRegHandshake,
  FaUserCheck,
  FaEye,
  FaRegCalendarCheck,
  FaTools,
  FaHome,
  FaSmile,
  FaBoxOpen,
  FaHandshake,
} from "react-icons/fa";
import Swastik from "../../assets/images/swastik.png";
import {
  Link,
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom";
import shape1 from "../../assets/images/shapes/about-1-shape-2.png";
import OwlCarousel from "react-owl-carousel3";
import shape2 from "../../assets/images/shapes/service-bg-shape-2-rtl.png";
import FAQSection from "../../Components/FAQSection/FAQ";
import TestimonialImg1 from "../../assets/images/resources/testi-1-1.jpg";
import TestimonialImg2 from "../../assets/images/resources/testi-1-2.jpg";
import TestimonialImg3 from "../../assets/images/resources/testi-1-3.jpg";
import TestimonialImg4 from "../../assets/images/resources/testi-1-4.jpg";
import DailyPooja from "../../assets/images/new/DailyPooja.jpg";
import Ecart from "../../assets/images/new/e-cart.jpg";
import Horoscope from "../../assets/images/new/Horoscope.jpg";
import panditBooking from "../../assets/images/new/panditBooking.jpg";
import poojaAtTemple from "../../assets/images/new/poojaAtTemple.jpg";
import templeBooking from "../../assets/images/new/templeBooking.jpg";
import batuk from "../../assets/images/new/fav-removebg-preview.png";
import ExitIntentModal from "./ExitIntentModal";
import { Helmet } from "react-helmet-async";
import PujaBookingBannerImg from "../../assets/images/new/PoojaBookingbannerImg.png";
import EstoreBannerImg from "../../assets/images/new/E-Storebanner.png";
import HoroscopeBannerImg from "../../assets/images/new/HoroscopeBanner.png";
import PujaAtTempleBannerImg from "../../assets/images/new/PujaAtTempleBannerImg.png";
import DailyPujaBookingBannerImg from "../../assets/images/new/DailyPoojaBookingBannerImg.png";
import DarshanBookingBannerImg from "../../assets/images/new/DarshanBookingBannerImg.png";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import Support from "../../Components/SupportComponent/Support";
import { MyBookPanditPujaListAPI } from "../../ApiServices/BookPanditAPI/BookPanditAPI";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { GetPopularPujaAPI } from "../../ApiServices/BookPanditAPI/BookPanditAPI";
import { GetPopularDailyPujaAPI } from "../../ApiServices/DailyPanditAPI/DailyPanditApi";
import BlogCarousel from "../../Components/BlogsSection/BlogsSection";
import "../../Components/DownLoadApp/DownlaodAppLandingPage.css";
import mockup from "../../assets/images/new/mokup.png";
import AppImg from "../../assets/images/new/AppImg.png";
import ComingSoonModal from "../../Components/ComingSoonModal";
import TrendingCategoriesSection from "../../Components/TrendingCategories/TrendingCategoriesSection";


const ServicesLandingPage = () => {
  const [slug, setSlug] = useState("");
  const [pujaListData, setPujaListData] = useState([]);
  const [pujaDailyListData, setDailyPujaListData] = useState([]);
  const { setLoader, pujaStatus, setPujaStatus } = useContext(LoaderContext);
  const [showComingsoonModal, setShowComingSoonModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const service = searchParams.get("servicename");
  const { servicename } = useParams();
  const [showExitIntentModal, setShowExitIntentModal] = useState(false);
  const data = [
    {
      headerName: "Offline Puja Booking Service",
      Imgabout1: About1,
      Imgabout2: panditBooking,
      tagLine: "Embrace Divinity with Temple Pujas",
      route: "/services/book-puja",
      serviceBannerImg: PujaBookingBannerImg,
      sectionTitle: "Book an Experienced Pandit for Your Puja",
      serviceName: "puja-booking",
      howItWorksMainHeading: "Effortless Path to Divine Blessings",
      howItWorks: [
        {
          howItWorksTitle: "Select Your Ceremony",
          howItWorksDesc:
            "Choose the ritual you want to perform- a wedding, housewarming, naming ceremony, or any special puja. ",
        },
        {
          howItWorksTitle: "Book Your Puja",
          howItWorksDesc:
            "Our expert pandits ensure each ritual is conducted with care, devotion, and attention to sacred details. ",
        },
        {
          howItWorksTitle: "Embrace Sacred Vibes",
          howItWorksDesc:
            "Pandit leads your ceremony with care. Feel the divine energy, connect with your faith, and receive health, happiness, and prosperity blessings. ",
        },
      ],
      testimonials: [
        {
          Desc: "I booked a Satyanarayan Puja through My OmNamo, and everything was perfectly arranged. The pandit was knowledgeable, punctual, and performed the rituals with devotion. Highly recommended.",
          name: "Rajesh Singh.",
          location: "Delhi",
        },
        {
          Desc: " My Griha Pravesh Puja was conducted beautifully. The pandit arrived on time with all the required materials. The entire process was smooth and blessed. Thank you, My OmNamo.",
          name: "Priya Mane",
          location: "Nashik",
        },
        {
          Desc: "I needed a Navagraha Shanti puja, and My OmNamo made it so easy! The chanting, rituals, and arrangements were all done perfectly. Truly a divine experience.",
          name: "Amit Kapoor",
          location: "Mumbai",
        },
      ],
      FaqObj: [
        {
          question: "What types of puja’s can I book?",
          answer:
            "You can book a variety of rituals, including Ganpati puja, Navratri Aarti, Lakshmi puja, and more.",
          color: "#ffa415",
        },
        {
          question: "Can I book recurring pujas?",
          answer:
            "Absolutely! You can schedule daily, weekly, or multi-day rituals as per your needs.",
          color: "#fc5528",
        },
        {
          question: "Are the pandits experienced and qualified?",
          answer:
            "Yes, all our pandits are experienced, well-trained, and follow proper Vedic rituals.",
          color: "#8139e7",
        },
        {
          question: "Can I book a puja for a temple or home location?",
          answer:
            "Yes, you can book a puja for your home, temple, or any preferred location.",
          color: "#8139e7",
        },
        {
          question: "Do you offer online puja services?",
          answer:
            "Yes, we offer virtual pujas where pandits perform rituals online.",
          color: "#8139e7",
        },
        // {
        //   question: "Why is it important How Volunteer?",
        //   answer:
        //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
        //   color: "#399be7",
        // },
      ],
      metaTitle: "Book Puja Online - Experienced Pandits for All Ceremonies",
      metaDescription:
        "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
      cannonicalLink: "https://www.myomnamo.com/services/puja-booking",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Puja Booking",
            item: "https://www.myomnamo.com/services/puja-booking",
          },
        ],
      },

      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Book Puja Online - Experienced Pandits for All Ceremonies",
        url: "https://www.myomnamo.com/services/puja-booking",
        description:
          "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
        publisher: {
          "@type": "Organization",
          name: "MyOmNamo",
        },
      },

      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "What types of puja’s can I book?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "You can book a variety of rituals, including Ganpati puja, Navratri Aarti, Lakshmi puja, and more.",
            },
          },
          {
            "@type": "Question",
            name: "Can I book recurring pujas?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Absolutely! You can schedule daily, weekly, or multi-day rituals as per your needs.",
            },
          },
          {
            "@type": "Question",
            name: "Are the pandits experienced and qualified?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, all our pandits are experienced, well-trained, and follow proper Vedic rituals.",
            },
          },
          {
            "@type": "Question",
            name: "Can I book a puja for a temple or home location?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, you can book a puja for your home, temple, or any preferred location.",
            },
          },
          {
            "@type": "Question",
            name: "Do you offer online puja services?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, we offer virtual pujas where pandits perform rituals online.",
            },
          },
        ],
      },
      metaData: {
        title: "Book Puja Online - Experienced Pandits for All Ceremonies",
        description:
          "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/puja-booking",
        siteName: "MyOmNamo",
        locale: "en_IN",
      },
      mainContent:
        "Make your special moments sacred with the guidance of an experienced pandit. Whether it’s a wedding, housewarming, naming ceremony, or any puja, a pandit ensures each ritual is done with care and devotion. Their knowledge of traditions brings peace and positivity to your home or event. From small home ceremonies to grand events, we bring positivity and tradition to your gathering. Performing rituals, helps you connect with your faith and look for blessings for health, happiness, and prosperity. Make every ceremony special and memorable with an experienced pandit who guides each step with care and kindness.",
    },
    {
      headerName: "Daily Puja Booking Service",
      Imgabout1: About1,
      Imgabout2: DailyPooja,
      tagLine: "Embrace Divinity with Temple Pujas",
      sectionTitle: "Book a Pandit for Daily Puja at Your Convenience",
      serviceBannerImg: DailyPujaBookingBannerImg,
      serviceName: "daily-puja-booking",
      howItWorksMainHeading: "Book a Pandit for Daily Puja at Your Convenience",
      howItWorks: [
        {
          howItWorksTitle: "Choose Your Ritual",
          howItWorksDesc:
            "Whether it's Ganpati Puja, Navratri Aarti, or a simple morning prayer, select the service you need. We’ll connect you with an experienced pandit. ",
        },
        {
          howItWorksTitle: "Schedule Your Time",
          howItWorksDesc:
            "Pick a date and time that fits your routine. Pandits are available every morning and evening, so you can schedule rituals at your convenience. ",
        },
        {
          howItWorksTitle: "Experience Divine Blessings",
          howItWorksDesc:
            "Your dedicated pandit arrives with all the necessary items for the Puja. Feel peace, positivity, and divine energy fill your space.",
        },
      ],
      testimonials: [
        {
          Desc: " I booked a daily Ganesh Puja, and it has brought so much positivity to my home. The pandit performs the rituals with devotion, and everything is well-organized. Truly grateful.",
          name: "Anjali Rajput",
          location: "Mumbai",
        },
        {
          Desc: " My family wanted a daily Shiv Abhishek, and My OmNamo made it effortless. The pandit is punctual, knowledgeable, and follows proper Vedic traditions. Highly recommended.",
          name: "Suresh Kale",
          location: "Nashik",
        },
        {
          Desc: "I opted for a monthly Lakshmi Puja service, and the experience has been wonderful. The prayers are performed with sincerity, bringing peace and prosperity to our home.",
          name: "Meera Savant",
          location: "Bangalore",
        },
      ],
      FaqObj: [
        {
          question: "What is a daily puja booking service?",
          answer:
            "It allows you to book a pandit for performing daily pujas at your home or temple.",
          color: "#ffa415",
        },
        {
          question: "How do I book a pandit for my ritual?",
          answer:
            "You can easily book a pandit online by selecting your ceremony, choosing a date, and confirming your booking.",
          color: "#fc5528",
        },
        {
          question: "Can I choose a specific pandit?",
          answer:
            "Yes, you can choose a pandit based on availability and your preferred language or tradition.",
          color: "#8139e7",
        },
        {
          question: "Can I schedule pujas at a fixed time daily?",
          answer:
            "Yes, you can set a fixed time for your daily puja at your convenience.",
          color: "#8139e7",
        },
        {
          question: "Can I book a virtual daily puja?",
          answer: "Yes, we offer online pujas where pandits perform rituals.",
          color: "#8139e7",
        },
        // {
        //   question: "Why is it important How Volunteer?",
        //   answer:
        //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
        //   color: "#399be7",
        // },
      ],
      route: "/services/daily-booking",
      metaTitle:
        "Daily Puja Booking Online - Trusted Pandits Morning & Evening Rituals",
      metaDescription:
        "Book an experienced pandit for your daily puja. Choose your ritual, pick a time, and welcome divine blessings to your home easily. Book now for morning or evening.",
      cannonicalLink: "https://www.myomnamo.com/services/daily-puja-booking",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Daily Puja Booking",
            item: "https://www.myomnamo.com/services/daily-puja-booking",
          },
        ],
      },
      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Daily Puja Booking Online - Trusted Pandits Morning & Evening Rituals",
        url: "https://www.myomnamo.com/services/daily-puja-booking",
        description:
          "Book an experienced pandit for your daily puja. Choose your ritual, pick a time, and welcome divine blessings to your home easily. Book now for morning or evening.",
        publisher: {
          "@type": "Organization",
          name: "MyOmNamo",
        },
      },
      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "What is a daily puja booking service?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "It allows you to book a pandit for performing daily pujas at your home or temple.",
            },
          },
          {
            "@type": "Question",
            name: "How do I book a pandit for my ritual?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "You can easily book a pandit online by selecting your ceremony, choosing a date, and confirming your booking.",
            },
          },
          {
            "@type": "Question",
            name: "Can I choose a specific pandit?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, you can choose a pandit based on availability and your preferred language or tradition.",
            },
          },
          {
            "@type": "Question",
            name: "Can I schedule pujas at a fixed time daily?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, you can set a fixed time for your daily puja at your convenience.",
            },
          },
          {
            "@type": "Question",
            name: "Can I book a virtual daily puja?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, we offer online pujas where pandits perform rituals.",
            },
          },
        ],
      },
      metaData: {
        title:
          "Daily Puja Booking Online - Trusted Pandits Morning & Evening Rituals",
        description:
          "Book an experienced pandit for your daily puja. Choose your ritual, pick a time, and welcome divine blessings to your home easily. Book now for morning or evening.",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/daily-puja-booking",
        siteName: "MyOmNamo",
        locale: "en_IN",
      },
      mainContent:
        "Looking for a pandit to perform daily pujas at home or at your event? Experienced pandits are available every morning and evening to guide you through your spiritual experience with care and devotion. Whether it's a 10-day Ganpati puja, a Navratri aarti, or any multi-day ceremony, we handle each step with accuracy and respect for tradition. From chanting mantras to performing aartis, we ensure your rituals are done properly. Bring peace, positivity, and divine blessings to your space every day. Experience divine blessings every day with a trusted pandit guiding your rituals.",
    },
    {
      headerName: "Online Puja Samagri Store",
      Imgabout1: About1,
      Imgabout2: Ecart,
      tagLine: "Embrace Divinity with Temple Pujas",
      serviceBannerImg: EstoreBannerImg,
      route: "/my-store",
      serviceName: "e-store",
      howItWorksMainHeading: "Puja Shopping Made Simple With E-store",
      howItWorks: [
        {
          howItWorksTitle: "Browse & Select",
          howItWorksDesc:
            "Explore our wide range of puja samagri. Choose puja samgari or complete puja kits customised to your spiritual needs. ",
        },
        {
          howItWorksTitle: "Order & Pay",
          howItWorksDesc:
            "Add products to your cart, securely check out, and choose convenient payment options for a smooth shopping experience. ",
        },
        {
          howItWorksTitle: "Receive & Worship",
          howItWorksDesc:
            "Get your order delivered to your door. Perform your rituals peacefully with everything you need ready and sacred.",
        },
      ],
      testimonials: [
        {
          Desc: " I ordered a Lakshmi idol and Rudraksha mala, and the quality was amazing. The items were well-packed and delivered on time. Truly satisfied.",
          name: "Puja More.",
          location: "Pune",
        },
        {
          Desc: " I purchased a complete puja kit, and it made my rituals so convenient. Everything was authentic and spiritually blessed. Highly recommend.",
          name: "Vikas Rathi",
          location: "Bangalore",
        },
        {
          Desc: "I bought incense sticks and a shankha from the E-Store. The delivery was quick, and the packaging was perfect. Will shop again.",
          name: "Meenal Shinde.",
          location: "Jaipur",
        },
      ],
      FaqObj: [
        {
          question: "What products do you offer?",
          answer:
            "We provide puja samagri, complete kits, idols, incense, flowers, and everything needed for daily rituals or special ceremonies.",
          color: "#ffa415",
        },
        {
          question: "Do you offer fast delivery?",
          answer:
            "Yes! We ensure quick and reliable delivery so you get your items on time for your puja or festival.",
          color: "#fc5528",
        },
        {
          question: "Are the products authentic and blessed?",
          answer:
            "Yes, our products are sourced from trusted vendors and many items are spiritually blessed.",
          color: "#8139e7",
        },
      ],
      sectionTitle: "Your One-Stop Online E-Store",
      metaTitle: "Online Puja Samagri Store - Buy Puja Items at MyOmNamo",
      metaDescription:
        "Online shopping for authentic Puja samagri and pooja items at MyOmNamo. Explore a wide range of spiritual products for all your rituals and ceremonies. Fast delivery and trusted quality.",
      cannonicalLink: "https://www.myomnamo.com/services/e-store",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Puja Samagri Store",
            item: "https://www.myomnamo.com/services/e-store",
          },
        ],
      },
      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Online Puja Samagri Store - Buy Puja Items at MyOmNamo",
        url: "https://www.myomnamo.com/services/e-store",
        description:
          "Online shopping for authentic Puja samagri and pooja items at MyOmNamo. Explore a wide range of spiritual products for all your rituals and ceremonies. Fast delivery and trusted quality.",
        publisher: {
          "@type": "Organization",
          name: "MyOmNamo",
        },
      },
      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "What products do you offer?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "We provide puja samagri, complete kits, idols, incense, flowers, and everything needed for daily rituals or special ceremonies.",
            },
          },
          {
            "@type": "Question",
            name: "Do you offer fast delivery?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes! We ensure quick and reliable delivery so you get your items on time for your puja or festival.",
            },
          },
          {
            "@type": "Question",
            name: "Are the products authentic and blessed?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, our products are sourced from trusted vendors and many items are spiritually blessed.",
            },
          },
        ],
      },
      metaData: {
        title: "Online Puja Samagri Store - Buy Puja Items at MyOmNamo",
        description:
          "Online shopping for authentic Puja samagri and pooja items at MyOmNamo. Explore a wide range of spiritual products for all your rituals and ceremonies. Fast delivery and trusted quality.",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/e-store",
        siteName: "MyOmNamo",
        locale: "en_IN",
      },

      mainContent:
        "Shop for all your puja needs from home. Get puja samagri, complete puja kits, idols, incense, and more. Whether it's for daily pujas or special festivals, have everything ready for your rituals. No need to visit multiple shops, just browse and get items delivered to your door.  Make every ceremony meaningful with the right products, from sacred flowers to holy offerings. Celebrate traditions easily, knowing you have everything needed for a peaceful and complete puja experience. Keep your devotion strong with the right products for every spiritual occasion.",
    },
    {
      headerName: "Online Darshan Booking",
      Imgabout1: About1,
      Imgabout2: templeBooking,
      tagLine: "Embrace Divinity with Temple Pujas",
      sectionTitle: "Easy Temple Darshan Booking Online",
      serviceBannerImg: DarshanBookingBannerImg,
      serviceName: "darshan-booking",
      cannonicalLink: "https://www.myomnamo.com/services/darshan-booking",
      route: "/darshan-booking",
      howItWorksMainHeading: "Simple & Time-Saving Darshan Booking",
      howItWorks: [
        {
          howItWorksTitle: "Choose Your Temple",
          howItWorksDesc:
            "Select your temple and preferred date for darshan. Plan your visit effortlessly, even during peak times. ",
        },
        {
          howItWorksTitle: "Book Your Slot",
          howItWorksDesc:
            "Reserve your darshan slot online in minutes. Avoid long queues and secure a peaceful, hassle-free temple experience.",
        },
        {
          howItWorksTitle: "Get Confirmation",
          howItWorksDesc:
            "Receive instant booking confirmation via email or SMS. Show your details at the temple and enjoy your visit stress-free.",
        },
      ],
      testimonials: [
        {
          Desc: " Booking temple darshan online saved me so much time! No long queues and the process was smooth. Truly a divine experience.",
          name: "Rohit Pawar.",
          location: "Yeola",
        },
        {
          Desc: "I booked a VIP darshan for my family, and everything went perfectly. The confirmation was instant, and we had a peaceful visit.",
          name: "Neha Tile",
          location: "Nagpur",
        },
        {
          Desc: "This service made temple visits stress-free. I booked my darshan in advance and had a smooth entry without any hassle. Highly recommended.",
          name: "Amit Patil",
          location: "Jaipur",
        },
      ],
      FaqObj: [
        {
          question: "What is the Darshan Booking service?",
          answer:
            "Our service allows you to book temple darshan online for a hassle-free spiritual experience.",
          color: "#ffa415",
        },
        {
          question: "Can I book darshan for multiple people?",
          answer:
            "Yes, you can book darshan for yourself, your family, or your friends in one go. Just add their details during booking.",
          color: "#fc5528",
        },
        {
          question: "Is online booking available for special events?",
          answer:
            "Yes, you can book darshan for festivals, special pujas, or daily visits — even during peak times.",
          color: "#8139e7",
        },
        {
          question: "Are VIP or special darshan tickets available?",
          answer:
            "Yes, we offer VIP or express darshan bookings at select temples.",
          color: "#8139e7",
        },
      ],
      metaTitle:
        "Online Temple Darshan Booking - Plan Your Visit Now with MyOmNamo",
      metaDescription:
        "Book temple darshan online and avoid waiting. Secure your slot, receive instant confirmation, and focus on your prayers. Start your booking now!",
      canonicalLink: "https://www.myomnamo.com/services/darshan-booking",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Darshan Booking",
            item: "https://www.myomnamo.com/services/darshan-booking",
          },
        ],
      },
      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Online Temple Darshan Booking - Plan Your Visit Now with MyOmNamo",
        url: "https://www.myomnamo.com/services/darshan-booking",
        description:
          "Book temple darshan online and avoid waiting. Secure your slot, receive instant confirmation, and focus on your prayers. Start your booking now!",
        publisher: {
          "@type": "Organization",
          name: "MyOmNamo",
        },
      },
      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "What is the Darshan Booking service?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Our service allows you to book temple darshan online for a hassle-free spiritual experience.",
            },
          },
          {
            "@type": "Question",
            name: "Can I book darshan for multiple people?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, you can book darshan for yourself, your family, or your friends in one go. Just add their details during booking.",
            },
          },
          {
            "@type": "Question",
            name: "Is online booking available for special events?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, you can book darshan for festivals, special pujas, or daily visits — even during peak times.",
            },
          },
          {
            "@type": "Question",
            name: "Are VIP or special darshan tickets available?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, we offer VIP or express darshan bookings at select temples.",
            },
          },
        ],
      },
      metaData: {
        title:
          "Online Temple Darshan Booking - Plan Your Visit Now with MyOmNamo",
        description:
          "Book temple darshan online and avoid waiting. Secure your slot, receive instant confirmation, and focus on your prayers. Start your booking now!",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/darshan-booking",
        siteName: "MyOmNamo",
        locale: "en_IN",
      },
      mainContent:
        "Plan your temple visit easily! Book your darshan in advance and skip the long queues. Whether you are visiting for a festival, special puja, or daily prayers, secure your spot in just a few steps. Enjoy a peaceful visit, offer your prayers, and look for blessings without the stress of waiting. Ideal for families, elderly devotees, or anyone wanting a smooth experience. Focus on your devotion and fully immerse yourself in the sacred atmosphere. Booking your darshan makes your visit more organized, giving you more time for prayer and reflection.",
    },
    {
      headerName: "Temple Puja Booking",
      Imgabout1: About1,
      Imgabout2: poojaAtTemple,
      tagLine: "Embrace Divinity with Temple Pujas",
      serviceBannerImg: PujaAtTempleBannerImg,
      route: "/pooja-at-temple",
      cannonicalLink: "https://www.myomnamo.com/services/temple-puja-booking",
      serviceName: "temple-puja",
      sectionTitle: "Perform a Sacred Puja at the Temple",
      howItWorksMainHeading: "Receive Sacred Blessings",
      howItWorks: [
        {
          howItWorksTitle: "Choose Your Puja",
          howItWorksDesc:
            "Choose from simple offerings or elaborate ceremonies, and personalize rituals for your spiritual intentions.  ",
        },
        {
          howItWorksTitle: "Book Effortlessly",
          howItWorksDesc:
            "From gathering offerings to preparing the sacred space, we ensure everything is ready so you can focus on your prayers without any worries.",
        },
        {
          howItWorksTitle: "Experience Divinity",
          howItWorksDesc:
            "Participate in sacred rituals, chant mantras, and receive blessings for positivity and well-being.",
        },
      ],
      testimonials: [
        {
          Desc: " I booked a puja at the temple, and everything was perfectly arranged. The rituals were performed beautifully, and I felt truly blessed.",
          name: "Anjali Raut",
          location: "Kolhapur",
        },
        {
          Desc: "Booking a temple puja online was so convenient. No long waits, everything was well-organized, and the prasad delivery was a lovely touch",
          name: "Vikas Mane",
          location: "Delhi",
        },
        {
          Desc: "The puja was conducted exactly as promised, with complete devotion and care. It was a peaceful and divine experience. Highly recommended.",
          name: "Priya Kadam",
          location: "Vashi",
        },
      ],
      FaqObj: [
        {
          question: "What is the Puja at Temple service?",
          answer:
            "Our service allows you to book a temple puja online, ensuring a smooth and hassle-free experience.",
          color: "#ffa415",
        },
        {
          question: "How do I book a puja?",
          answer:
            "You can book online or at the temple. Choose the puja type, date, and time.",
          color: "#fc5528",
        },
        {
          question: "What types of pujas are available?",
          answer:
            "We offer pujas for birthdays, anniversaries, festivals, personal prayers, and special ceremonies.",
          color: "#8139e7",
        },
        {
          question: "Are special or private pujas available?",
          answer:
            "Yes, some temples offer private pujas with personalized rituals.",
          color: "#8139e7",
        },
      ],
      metaTitle: "Book Temple Puja Online - Sacred Rituals for Every Occasion",
      metaDescription:
        "Book a temple puja for birthdays, anniversaries, or festivals. Experience sacred rituals with care and devotion. Focus on prayers while we handle the rest.",
      canonicalLink: "https://www.myomnamo.com/services/temple-puja-booking",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Temple Puja",
            item: "https://www.myomnamo.com/services/temple-puja-booking",
          },
        ],
      },
      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Book Temple Puja Online - Sacred Rituals for Every Occasion",
        url: "https://www.myomnamo.com/services/temple-puja-booking",
        description:
          "Book a temple puja for birthdays, anniversaries, or festivals. Experience sacred rituals with care and devotion. Focus on prayers while we handle the rest.",
        publisher: {
          "@type": "Organization",
          name: "MyOmNamo",
        },
      },
      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "What is the Puja at Temple service?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Our service allows you to book a temple puja online, ensuring a smooth and hassle-free experience.",
            },
          },
          {
            "@type": "Question",
            name: "How do I book a puja?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "You can book online or at the temple. Choose the puja type, date, and time.",
            },
          },
          {
            "@type": "Question",
            name: "What types of pujas are available?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "We offer pujas for birthdays, anniversaries, festivals, personal prayers, and special ceremonies.",
            },
          },
          {
            "@type": "Question",
            name: "Are special or private pujas available?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, some temples offer private pujas with personalized rituals.",
            },
          },
        ],
      },
      metaData: {
        title: "Book Temple Puja Online - Sacred Rituals for Every Occasion",
        description:
          "Book a temple puja for birthdays, anniversaries, or festivals. Experience sacred rituals with care and devotion. Focus on prayers while we handle the rest.",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/temple-puja-booking",
        siteName: "MyOmNamo",
        locale: "en_IN",
      },
      mainContent:
        "Make your temple visit more special with a peaceful puja. Book a puja for any occasion, whether it be birthdays, anniversaries, festivals, or personal prayers. Let the rituals be performed with care and devotion, bringing positivity and blessings into your life. Whether it’s a small offering or a full ceremony, experience the divine atmosphere and connect deeply with your faith. Perfect for individuals, families, or groups looking for a sacred experience. Focus on your prayers while the arrangements are taken care of. Make every visit special and full of positive energy.",
    },
    {
      headerName: "Horoscope Reading",
      Imgabout1: About1,
      Imgabout2: Horoscope,
      tagLine: "Embrace Divinity with Temple Pujas",
      route: "/horoscope",
      serviceBannerImg: HoroscopeBannerImg,
      cannonicalLink: "https://www.myomnamo.com/services/horoscope",
      serviceName: "horoscope",
      sectionTitle: "Know What Your Stars Say",
      howItWorksMainHeading: "How Our Horoscope Reading Works",
      howItWorks: [
        {
          howItWorksTitle: "Choose Your Sign",
          howItWorksDesc:
            "Select your zodiac sign to receive a personalized reading about your life, emotions, and future possibilities.",
        },
        {
          howItWorksTitle: "Get Insights Instantly",
          howItWorksDesc:
            "Access daily, weekly, or yearly horoscopes with detailed guidance on love, career, and well-being for extra clarity.",
        },
        {
          howItWorksTitle: "Embrace Your Path",
          howItWorksDesc:
            "Use your horoscope’s advice to make decisions, discover lucky days, and invite more happiness and balance into your life.",
        },
      ],
      testimonials: [
        {
          Desc: " I booked a puja at the temple, and everything was perfectly arranged. The rituals were performed beautifully, and I felt truly blessed.",
          name: "Anjali Raut",
          location: "Kolhapur",
        },
        {
          Desc: "Booking a temple puja online was so convenient. No long waits, everything was well-organized, and the prasad delivery was a lovely touch",
          name: "Vikas Mane",
          location: "Delhi",
        },
        {
          Desc: "The puja was conducted exactly as promised, with complete devotion and care. It was a peaceful and divine experience. Highly recommended.",
          name: "Priya Kadam",
          location: "Vashi",
        },
      ],
      FaqObj: [
        {
          question: "What is the Puja at Temple service?",
          answer:
            "Our service allows you to book a temple puja online, ensuring a smooth and hassle-free experience.",
          color: "#ffa415",
        },
        {
          question: "How do I book a puja?",
          answer:
            "You can book online or at the temple. Choose the puja type, date, and time.",
          color: "#fc5528",
        },
        {
          question: "What types of pujas are available?",
          answer:
            "We offer pujas for birthdays, anniversaries, festivals, personal prayers, and special ceremonies.",
          color: "#8139e7",
        },
        {
          question: "Are special or private pujas available?",
          answer:
            "Yes, some temples offer private pujas with personalized rituals.",
          color: "#8139e7",
        },
      ],
      metaTitle: "Horoscope Readings by Zodiac Sign - Know Your Future",
      metaDescription:
        "Find guidance for love, career, and life decisions with a horoscope reading. Explore daily, weekly, or yearly insights tailored to your zodiac sign. Book a consultation.",
      canonicalLink: "https://www.myomnamo.com/services/horoscope",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Horoscope",
            item: "https://www.myomnamo.com/services/horoscope",
          },
        ],
      },
      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Horoscope Readings by Zodiac Sign - Know Your Future",
        url: "https://www.myomnamo.com/services/horoscope",
        description:
          "Find guidance for love, career, and life decisions with a horoscope reading. Explore daily, weekly, or yearly insights tailored to your zodiac sign. Book a consultation.",
        publisher: {
          "@type": "Organization",
          name: "MyOmNamo",
        },
      },
      metaData: {
        title: "Horoscope Readings by Zodiac Sign - Know Your Future",
        description:
          "Find guidance for love, career, and life decisions with a horoscope reading. Explore daily, weekly, or yearly insights tailored to your zodiac sign. Book a consultation.",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/horoscope",
        siteName: "MyOmNamo",
        locale: "en_IN",
      },
      mainContent:
        "Find out what your future holds with a simple horoscope reading. Learn about your day, week, or year efficiently. Get insights about love, work, health, and more. Whether you have a big decision to make or are just curious, a horoscope reading can guide you. Find out lucky days, helpful advice, and ways to bring more happiness into your life. Perfect for anyone looking for extra clarity and peace of mind. Let the stars guide you toward a brighter future.",
    },
    {
      headerName: "Online Prasad Booking Service",
      Imgabout1: About1,
      Imgabout2: Ecart,
      tagLine: "Embrace Divinity with Temple Prasad",
      serviceBannerImg: prasadBooking,
      route: "/prasad-list",
      serviceName: "online-prasad-booking",
      howItWorksMainHeading: "Book Prasad Online with Myomnamo",
      howItWorks: [
        {
          howItWorksTitle: "Choose & Customize",
          howItWorksDesc:
            "Select your preferred prasad, meal time, and quantity. Pick from a variety of sacred offerings prepared with devotion. ",
        },
        {
          howItWorksTitle: "Book & Pay",
          howItWorksDesc:
            "Complete your booking with a few clicks. Enjoy secure payment options for a hassle-free experience",
        },
        {
          howItWorksTitle: "Receive & Blessings",
          howItWorksDesc:
            "Get the divine prasad delivered to your home. Savour the sacred taste and feel the blessings of the divine.",
        },
      ],
      testimonials: [
        {
          Desc: " I ordered a Lakshmi idol and Rudraksha mala, and the quality was amazing. The items were well-packed and delivered on time. Truly satisfied.",
          name: "Puja More.",
          location: "Pune",
        },
        {
          Desc: " I purchased a complete puja kit, and it made my rituals so convenient. Everything was authentic and spiritually blessed. Highly recommend.",
          name: "Vikas Rathi",
          location: "Bangalore",
        },
        {
          Desc: "I bought incense sticks and a shankha from the E-Store. The delivery was quick, and the packaging was perfect. Will shop again.",
          name: "Meenal Shinde.",
          location: "Jaipur",
        },
      ],
      FaqObj: [
        {
          question: "Which temples' prasad can I book?",
          answer:
            "You can book prasad from famous temples, including Tirupati Balaji, Shirdi Sai Baba, and Ayodhya Ram Mandir, all prepared with traditional devotion.",
          color: "#ffa415",
        },
        {
          question: "How long does delivery take?",
          answer:
            "Delivery time varies by location, but we ensure your prasad reaches you fresh, typically within 3-7 business days after booking.",
          color: "#fc5528",
        },
        {
          question: "Is the prasad prepared hygienically?",
          answer:
            "Yes, all prasad is prepared in temple-approved kitchens following strict hygiene and traditional methods to maintain purity and sanctity.",
          color: "#8139e7",
        },
        {
          question: "Can I book prasad for special occasions?",
          answer:
            "Absolutely! You can book prasad in bulk for festivals, pujas, or family gatherings and share divine blessings with your loved ones.",
          color: "#8139e7",
        },
      ],
      sectionTitle: "Online Prasad Booking Service",
      metaTitle: "Online Prasad Booking - Receive Divine Blessings at Home",
      metaDescription:
        "Book authentic temple prasad online and enjoy sacred blessings at home. Select your meal time and quantity for a convenient spiritual experience. Order Now!",
      cannonicalLink: "https://www.myomnamo.com/services/online-prasad-booking",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",

        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Online Prasad Booking",
            item: "https://www.myomnamo.com/services/online-prasad-booking",
          },
        ],
      },
      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Online Prasad Booking - Receive Divine Blessings at Home",
        url: "https://www.myomnamo.com/services/online-prasad-booking",
        description:
          "Book authentic temple prasad online and enjoy sacred blessings at home. Select your meal time and quantity for a convenient spiritual experience. Order Now!",
        publisher: {
          "@type": "Organization",
          name: "MyOmNamo",
        },
      },
      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "Which temples' prasad can I book?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "You can book prasad from famous temples, including Tirupati Balaji, Shirdi Sai Baba, and Ayodhya Ram Mandir, all prepared with traditional devotion.",
            },
          },
          {
            "@type": "Question",
            name: "How long does delivery take?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Delivery time varies by location, but we ensure your prasad reaches you fresh, typically within 3-7 business days after booking.",
            },
          },
          {
            "@type": "Question",
            name: "Is the prasad prepared hygienically?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, all prasad is prepared in temple-approved kitchens following strict hygiene and traditional methods to maintain purity and sanctity.",
            },
          },
          {
            "@type": "Question",
            name: "Can I book prasad for special occasions?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Absolutely! You can book prasad in bulk for festivals, pujas, or family gatherings and share divine blessings with your loved ones.",
            },
          },
        ],
      },
      metaData: {
        title: "Online Puja Samagri Store - Buy Puja Items at MyOmNamo",
        description:
          "Online shopping for authentic Puja samagri and pooja items at MyOmNamo. Explore a wide range of spiritual products for all your rituals and ceremonies. Fast delivery and trusted quality.",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/e-store",
        siteName: "MyOmNamo",
        locale: "en_IN",
      },

      mainContent:
        "Book your sacred prasad online with Myomnamo and receive divine blessings at home. Choose fr.om famous temples like Tirupati Balaji, Shirdi Sai Baba, and Ayodhya. Select your preferred date, meal time, and the number of coupons needed. Each prasad is prepared with devotion and love, bringing the temple's spiritual essence to your doorstep. Enjoy the taste of tradition and the comfort of god's grace without leaving your home. Order now and feel the divine connection.",
    },
    {
      headerName: "Book Online Puja Services",
      Imgabout1: About1,
      Imgabout2: panditBooking,
      tagLine: "Book Online Puja Services",
      route: "/services/book-puja",
      serviceBannerImg: PujaBookingBannerImg,
      sectionTitle: "Book Online Puja Services",
      serviceName: "online-puja-services",
      howItWorksMainHeading: "Book Online Puja Services with Myomnamo",
      howItWorks: [
        {
          howItWorksTitle: "Choose Your Puja",
          howItWorksDesc:
            "Select from our sacred online pujas and book a skilled pandit for virtual rituals. Schedule your puja at least 2 days in advance.  ",
        },
        {
          howItWorksTitle: "Personalize & Confirm",
          howItWorksDesc:
            "Share your details and intentions for the puja. Receive a confirmation with samagri guidance and live puja timing. ",
        },
        {
          howItWorksTitle: "Witness & Receive Blessings ",
          howItWorksDesc:
            "Join the virtual puja from home, watch the rituals live, and receive divine blessings directly from our experienced pandits. ",
        },
      ],
      testimonials: [
        {
          Desc: "I booked a Satyanarayan Puja through My OmNamo, and everything was perfectly arranged. The pandit was knowledgeable, punctual, and performed the rituals with devotion. Highly recommended.",
          name: "Rajesh Singh.",
          location: "Delhi",
        },
        {
          Desc: " My Griha Pravesh Puja was conducted beautifully. The pandit arrived on time with all the required materials. The entire process was smooth and blessed. Thank you, My OmNamo.",
          name: "Priya Mane",
          location: "Nashik",
        },
        {
          Desc: "I needed a Navagraha Shanti puja, and My OmNamo made it so easy! The chanting, rituals, and arrangements were all done perfectly. Truly a divine experience.",
          name: "Amit Kapoor",
          location: "Mumbai",
        },
      ],
      FaqObj: [
        {
          question: "How does online puja work?",
          answer:
            "You book a puja, our pandit performs it virtually with proper rituals. You can watch live and receive blessings from anywhere. No physical presence is needed.",
          color: "#ffa415",
        },
        {
          question: "Can I customize the puja for my needs?",
          answer:
            "Yes, share your specific wishes during booking. Our pandits tailor the puja accordingly, whether for health, success, or other spiritual purposes. ",
          color: "#fc5528",
        },
        {
          question: "Do I need to arrange puja items?",
          answer:
            "No, we provide all sacred samagri. You only need a device (phone/laptop) to join the live session and participate spiritually.",
          color: "#8139e7",
        },
        {
          question: "Is online puja as effective as offline?",
          answer:
            " Absolutely. The power of puja depends on devotion and proper rituals. Our expert pandits ensure authenticity, making it equally sacred and effective.",
          color: "#8139e7",
        },

      ],
      metaTitle: "Book Online Puja Services - Virtual Rituals with Expert Pandits",
      metaDescription:
        "Book online puja services with experienced pandits. Receive sacred blessings at home through live virtual rituals. Schedule your spiritual experience today!",
      cannonicalLink: "https://www.myomnamo.com/services/online-puja-services",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Puja Booking",
            item: "https://www.myomnamo.com/services/puja-booking",
          },
        ],
      },

      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Book Puja Online - Experienced Pandits for All Ceremonies",
        url: "https://www.myomnamo.com/services/puja-booking",
        description:
          "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
        publisher: {
          "@type": "Organization",
          name: "MyOmNamo",
        },
      },

      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "What types of puja’s can I book?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "You can book a variety of rituals, including Ganpati puja, Navratri Aarti, Lakshmi puja, and more.",
            },
          },
          {
            "@type": "Question",
            name: "Can I book recurring pujas?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Absolutely! You can schedule daily, weekly, or multi-day rituals as per your needs.",
            },
          },
          {
            "@type": "Question",
            name: "Are the pandits experienced and qualified?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, all our pandits are experienced, well-trained, and follow proper Vedic rituals.",
            },
          },
          {
            "@type": "Question",
            name: "Can I book a puja for a temple or home location?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, you can book a puja for your home, temple, or any preferred location.",
            },
          },
          {
            "@type": "Question",
            name: "Do you offer online puja services?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, we offer virtual pujas where pandits perform rituals online.",
            },
          },
        ],
      },
      metaData: {
        title: "Book Online Puja Services - Virtual Rituals with Expert Pandits",
        description:
          "Book online puja services with experienced pandits. Receive sacred blessings at home through live virtual rituals. Schedule your spiritual experience today!",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/puja-booking",
        siteName: "MyOmNamo",
        locale: "en_IN",
      },
      mainContent:
        "Book online puja services with Myomnamo and connect with divine blessings from your home. Our trusted and experienced pandits perform puja virtually, ensuring authenticity and devotion. We provide sacred puja samagri and guide you through the setup for a seamless spiritual experience. Whether it's for peace, prosperity, or special occasions, let us help you fulfill your prayers with heartfelt rituals. Experience the power of tradition, no matter where you are. Start your spiritual journey today. Book your online puja now.",
    },
  ];
  console.log("pujaStatus", pujaStatus);

  const serviceData = data.find((item) => item.serviceName === servicename);

  console.log("serviceData", serviceData);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    const path = location.pathname;

    if (path.startsWith("/services/")) {
      const slugPart = path.replace("/services/", "");
      setSlug(slugPart || "default");

      if (slugPart === "horoscope") {
        setShowExitIntentModal(false);
        return; // Stop further execution
      }

      const modalClosed = sessionStorage.getItem("exit_modal_closed");

      // Scroll event listener
      const handleScroll = () => {
        if (!modalClosed && window.scrollY > 300) {
          setShowExitIntentModal(true);
          window.removeEventListener("scroll", handleScroll); // Remove listener after showing modal
        }
      };

      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    } else {
      setShowExitIntentModal(false);
    }
  }, [location]);
  const owlOptions = {
    items: 1,
    margin: 30,
    loop: false,
    smartSpeed: 700,
    nav: false,
    dots: true,
    autoplay: false,
    responsive: {
      0: { items: 1 },
      768: { items: 2 },
    },
  };

  useEffect(() => {
    if (servicename === "daily-puja-booking") {
      GetMyDailyBookPanditPujaListData();
    } else if (servicename === "puja-booking") {
      GetMyBookPanditPujaListData();
    }
  }, [servicename]);

  useEffect(() => {
    GetMyBookPanditPujaListData();
  }, []);

  const GetMyBookPanditPujaListData = async () => {
    setLoader(true);
    try {
      const response = await GetPopularPujaAPI(null);
      if (response) {
        setLoader(false);
        setPujaListData(response.DATA);
      }

      // if (response) {
      //   setLoader(false);
      //   const newList = response.DATA.filter(
      //     (item) => item.PUJA_TREND === "Yes"
      //   );
      //   setPujaListData(newList);
      // }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const GetMyDailyBookPanditPujaListData = async () => {
    setLoader(true);
    try {
      const response = await GetPopularDailyPujaAPI();

      if (response) {
        setLoader(false);
        setDailyPujaListData(response.DATA);
      }

      // if (response) {
      //   setLoader(false);
      //   const newList = response.DATA.filter(
      //     (item) => item.PUJA_TREND === "Yes"
      //   );
      //   setPujaListData(newList);
      // }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const ExitIntenModalOpen = () => {
    setShowExitIntentModal(true);
  };
  const key = location?.state?.key;
  const user_id = localStorage.getItem("userID");

  // const GetMyBookPanditPujaListData = async () => {
  //   setLoader(true);
  //   try {
  //     const response = await MyBookPanditPujaListAPI(user_id, 1, {
  //       START: 1,
  //       END: 10,
  //       WORD: "None",
  //       LATITUDE: "20.008581",
  //       LONGITUDE: "73.76413099999999",
  //     });

  //     if (response) {
  //       setLoader(false);
  //       const newList = response.DATA.filter(
  //         (item) => item.PUJA_TREND === "Yes"
  //       );
  //       setPujaListData(newList);
  //     }
  //   } catch (error) {
  //     setLoader(false);
  //     console.log(error);
  //   }
  // };

  console.log(serviceData?.serviceBannerImg);

  const reasons = [
    {
      title: "Verified and Experienced Pandits",
      description:
        "Our platform connects you with highly qualified and experienced pandits who specialise in Vedic rituals and Hindu ceremonies.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Hassle-Free Booking",
      description:
        "Book your puja online in just a few clicks! Our user-friendly interface allows you to easily select the ceremony, date, and location. ",
      icon: <FaRegCalendarCheck size={40} color="#8f3246" />,
    },
    {
      title: "Customized Rituals",
      description:
        "We offer pujas in different regional styles like North Indian, South Indian, Bengali, and Marathi. Whatever your tradition, we make sure the rituals match your customs and needs.",
      icon: <FaTools size={40} color="#8f3246" />,
    },
    {
      title: "Convenience at Your Doorstep",
      description:
        "Whether you need a pandit for a home ceremony or a temple ritual, we bring divine blessings to your doorstep with punctual and reliable service.",
      icon: <FaHome size={40} color="#8f3246" />,
    },
    {
      title: "Customer Satisfaction",
      description:
        "With hundreds of successful pujas conducted, we pride ourselves on delivering exceptional service that leaves our customers spiritually fulfilled and happy.",
      icon: <FaHandshake size={40} color="#8f3246" />,
    },
    {
      title: "All-Inclusive Packages",
      description:
        "From arranging pandits to providing puja samagri, we handle everything so you can focus on your prayers without stress.",
      icon: <FaBoxOpen size={40} color="#8f3246" />,
    },
  ];

  const PujaBookingWhyChooseUs = [
    {
      title: "Verified and Experienced Pandits",
      description:
        "Our platform connects you with highly qualified and experienced pandits who specialise in Vedic rituals and Hindu ceremonies.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Hassle-Free Booking",
      description:
        "Book your puja online in just a few clicks! Our user-friendly interface allows you to easily select the ceremony, date, and location.",
      icon: <FaRegCalendarCheck size={40} color="#8f3246" />,
    },
    {
      title: "Customized Rituals",
      description:
        "We offer pujas in different regional styles like North Indian, South Indian, Bengali, and Marathi. Whatever your tradition, we make sure the rituals match your customs and needs.",
      icon: <FaTools size={40} color="#8f3246" />,
    },
    {
      title: "Convenience at Your Doorstep",
      description:
        "Whether you need a pandit for a home ceremony or a temple ritual, we bring divine blessings to your doorstep with punctual and reliable service.",
      icon: <FaHome size={40} color="#8f3246" />,
    },
    {
      title: "Customer Satisfaction",
      description:
        "With hundreds of successful pujas conducted, we pride ourselves on delivering exceptional service th at leaves our customers spiritually fulfilled and happy.",
      icon: <FaHandshake size={40} color="#8f3246" />,
    },
    {
      title: "All-Inclusive Packages",
      description:
        "From arranging pandits to providing puja samagri, we handle everything so you can focus on your prayers without stress.",
      icon: <FaBoxOpen size={40} color="#8f3246" />,
    },
  ];
  const DailyPujaBookingWhyChooseUs = [
    {
      title: "Experienced Pandits",
      description:
        "Daily pujas are performed by skilled pandits with deep knowledge of Vedic rituals, ensuring authenticity.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Convenient Booking",
      description:
        "Easily book a pandit for daily puja at your preferred time, bringing spiritual practices to your doorstep",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Personalized Rituals",
      description:
        "We handle each puja with precision, respect, and customization, catering to your specific needs and traditions.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Comprehensive Service",
      description:
        "From mantra chanting to aarti, we ensure every aspect of your daily puja is performed accurately and traditionally.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Positive Environment",
      description:
        "Invite peace, positivity, and divine blessings into your home with our dedicated and devoted puja services.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Trusted Guidance",
      description:
        "Experience divine blessings every day with a trusted pandit guiding your rituals, fostering a deeper connection.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
  ];
  const DarshanBookingWhyChooseUs = [
    {
      title: "Skip the Lines",
      description:
        "Book your darshan online in advance, avoiding long queues and saving valuable time for a peaceful temple visit.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Easy Booking Process",
      description:
        "Our user-friendly platform allows you to book your darshan in just a few simple steps, making the process quick and convenient.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Plan with Ease",
      description:
        "Organize your temple visit easily, selecting your preferred date and time slot to align with your travel schedule.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Ideal for Everyone",
      description:
        "Whether you're a family, elderly devotee, or individual, our service ensures a smooth and stress-free experience for all.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },

    {
      title: "Guaranteed Entry",
      description:
        "Ensure your spot for festivals, special pujas, or daily prayers with a confirmed darshan booking.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },

    {
      title: "Organized Visit",
      description:
        "By booking your darshan, you'll have a more structured visit, providing you with ample time for prayer, reflection, and spiritual fulfilment.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
  ];
  const TempleBookingWhyChooseUs = [
    {
      title: "Easy Booking",
      description:
        "Book any temple puja online, anytime, from anywhere, quickly, simply, and hassle-free.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Experienced Pandits",
      description:
        "Our skilled and verified pandits perform rituals with full devotion and tradition.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Personalized Services",
      description:
        "Choose pujas to your needs, occasions, and preferences for a meaningful spiritual experience.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Live Updates",
      description:
        "Get real-time notifications on puja status and timing for peace of mind.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },

    {
      title: "Safe Payments",
      description:
        "Make secure online payments with full data encryption and protection.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },

    {
      title: "One-Stop Spiritual Hub",
      description:
        "Access all spiritual services, pandit booking, pujas, and darshan tickets in one place.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
  ];
  const HoroscopeWhyChooseUs = [
    {
      title: "Daily Zodiac Sign",
      description:
        "Get daily insights specific to your zodiac sign for better life alignment.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Accurate Predictions",
      description:
        "Get clear insights with precise forecasts based on your zodiac sign.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Personalized Guidance",
      description:
        "Experienced astrologer gives you customised insights to navigate life’s challenges and opportunities effectively.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Everyday Sunrise Sunset Information",
      description:
        "With a horoscope, stay updated with daily sunrise and sunset timings for spiritual harmony.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },

    {
      title: "Pre-Update on Festivals",
      description:
        "You will receive advance notifications for upcoming festivals and auspicious dates.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },

    {
      title: "Panchang Information",
      description:
        "We provide detailed Panchang data for informed decision-making and rituals.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
  ];
  const EStoreWhyChooseUs = [
    {
      title: "Authentic Products Only",
      description:
        " We offer 100% authentic and traditional puja samagri sourced from trusted vendors to maintain the sanctity of rituals.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "All-In-One Puja Kits",
      description:
        " Ready-to-use kits include every essential item needed for specific pujas, saving time and ensuring nothing is missed.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Wide Range of Items",
      description:
        "Explore an extensive collection of quality incense sticks, dhoop, kapur, and sacred items for every kind of pooja.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Nationwide Delivery",
      description:
        "We deliver across India with safe packaging to preserve the purity and freshness of every pooja item you order.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },

    {
      title: "Trusted by Devotees",
      description:
        "Thousands of satisfied customers trust our service for prompt delivery and the spiritual value of our curated samagri.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },

    {
      title: "Easy Online Ordering",
      description:
        "Enjoy a hassle-free shopping experience with secure payment options and doorstep delivery for all your spiritual needs.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
  ];
  const OnlinePujaWhyChooseUs = [
    {
      title: "Trusted & Vedic Pandits",
      description:
        "Our certified pandits have decades of experience, ensuring authentic Vedic rituals with proper mantras and vidhi for divine blessings.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Live Virtual Puja Experience",
      description:
        " Witness your puja in real-time via video call, interact with the pandit, and feel spiritually connected from anywhere in the world. ",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Flexible Scheduling",
      description:
        " Book pujas 48 hours in advance at your preferred time, including weekends, for a seamless spiritual experience.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Personalized Devotion",
      description:
        "Share your specific prayers and intentions—our pandits perform rituals with your needs in mind for a heartfelt connection.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },

    {
      title: "Spiritual Guidance",
      description:
        "Get expert advice on rituals, mantras, and post-puja practices to deepen your connection with the divine effortlessly.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },

    {
      title: "Easy Online Ordering",
      description:
        "Enjoy a hassle-free shopping experience with secure payment options and doorstep delivery for all your spiritual needs.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
  ];
  const PrasadWhyChooseUs = [
    {
      title: "Divine Blessings at Home",
      description:
        " Receive sacred prasad from famous temples, bringing the temple's spiritual essence and blessings directly to your doorstep.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Taste of Tradition",
      description:
        "Enjoy authentic, traditionally prepared prasad, made with devotion and the finest ingredients, offering a unique spiritual experience.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Convenient and Easy",
      description:
        "Select your preferred date, meal time, and quantity, making it simple to receive divine offerings without leaving your home.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Prepared with Devotion",
      description:
        " Each prasad is crafted with love and care, ensuring that you receive a pure and blessed offering from the chosen temple.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },

    {
      title: "Connect with the Divine",
      description:
        "Strengthen your spiritual connection and feel the comfort of God's grace through the sacred taste of blessed prasad.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },

    {
      title: "Hassle-Free Experience",
      description:
        "Skip the travel and long queues; order your prasad online with a few clicks for a seamless and fulfilling experience.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
  ];
  const serviceReasonsMap = {
    "puja-booking": PujaBookingWhyChooseUs,
    "daily-puja-booking": DailyPujaBookingWhyChooseUs,
    "darshan-booking": DarshanBookingWhyChooseUs,
    "temple-puja": TempleBookingWhyChooseUs,
    horoscope: HoroscopeWhyChooseUs,
    "e-store": EStoreWhyChooseUs,
    "online-prasad-booking": PrasadWhyChooseUs,
    'online-puja-services': OnlinePujaWhyChooseUs
  };
  console.log('serviceData', serviceData)
  const selectedReasons = serviceReasonsMap[servicename] || reasons;
  return (
    <div>
      <section className="page-header">
        <div
          className="page-header__bg_serviceBanner"
          style={{ backgroundImage: `url(${serviceData.serviceBannerImg})` }}
        ></div>
        <div className="container">
          <h1
            className="page-header__title bw-split-in-left"
          // onClick={ExitIntenModalOpen}
          >
            {serviceData.headerName}
          </h1>
        </div>
      </section>

      <Helmet>
        <title>{serviceData.metaTitle}</title>
        <meta name="description" content={serviceData.metaDescription} />
        <link rel="canonical" href={serviceData.cannonicalLink} />

        {/* Open Graph tags */}
        <meta property="og:title" content={serviceData.metaData.title} />
        <meta
          property="og:description"
          content={serviceData.metaData.description}
        />
        <meta property="og:image" content={serviceData.metaData.image} />
        <meta property="og:url" content={serviceData.metaData.url} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={serviceData.metaData.siteName} />
        <meta
          property="og:locale"
          content={serviceData.metaData.locale || "en_IN"}
        />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={serviceData.metaData.title} />
        <meta
          name="twitter:description"
          content={serviceData.metaData.description}
        />
        <meta name="twitter:image" content={serviceData.metaData.image} />

        {/* Breadcrumb JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(serviceData.breadcrumbSchema)}
        </script>

        {/* WebPage JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(serviceData.webpageSchema)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(serviceData.faqSchema)}
        </script>
      </Helmet>

      <section>
        <div className="container">
          <div className="row" style={{ marginBottom: "20px" }}>
            {/* <div
              className="col-xl-9"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <div
                className="about-one__image wow fadeInLeft"
                data-wow-delay="100ms"
              >
                <div className="about-one__image__one">
                  <img
                    src={data[key].Imgabout2}
                    alt="careox"
                    className="img-fluid" // Bootstrap className for responsiveness
                    style={{
                      width: "600px",
                      height: "300px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </div> */}

            <div
              className="col-md-10 wow fadeInRight d-flex"
              data-wow-delay="200ms"
            >
              <div
                className="about-one__content"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <div className="sec-title text-left">
                  <h6 className="sec-title__tagline bw-split-in-right">
                    <img className=" tagline-img" src={batuk} alt="" />
                    {serviceData.tagLine}
                  </h6>

                  <h3 className="sec-title__title bw-split-in-left">
                    {serviceData.sectionTitle}
                  </h3>
                </div>
                <p
                  className="about-one__content__text"
                  style={{ textAlign: "justify" }}
                >
                  {serviceData.mainContent}
                </p>
                {serviceData.serviceName === "horoscope" ? (
                  <div className="col-6 wow about-one__content">
                    {" "}
                    <Link to={serviceData.route} className="careox-btn">
                      View Details
                    </Link>
                  </div>
                ) : (
                  <div className="col-6 wow about-one__content">
                    {" "}
                    <Link to={serviceData.route}>
                      <button className="careox-btn">Book Now</button>
                    </Link>
                  </div>
                )}
                {/* <div className="row gutter-y-30"></div>
                <div className="about-one__content__border"></div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      {(servicename === "puja-booking" || servicename === "online-puja-services") ? (
        <TrendingCategoriesSection />
      ) : ''}


      {/* How it works */}

      <section className="service-one" style={{ padding: "30px 0" }}>
        <div
          className="service-one__shape-two"
          style={{ backgroundImage: `url(${shape2})` }}
        ></div>
        <div
          className="container"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className="row">
            <div className="col-12">
              <div
                className="sec-title text-center"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <h6 className="sec-title__tagline bw-split-in-right">
                  <img className=" tagline-img" src={batuk} alt="" />
                  How It Works{" "}
                </h6>

                <h3 className="sec-title__title bw-split-in-left">
                  {serviceData.howItWorksMainHeading}
                </h3>
              </div>
              <div
                class="row gutter-y-30 d-flex align-center justify-center"
                style={{ gap: "20px" }}
              >
                {serviceData.howItWorks?.map((item, index) => (
                  <div
                    className="col-lg-3 col-md-6 wow fadeInUp"
                    data-wow-delay="00ms"
                  >
                    <div
                      className="service-one__item text-center d-flex flex-column h-100"
                      style={{ color: "#a42642" }}
                    >
                      <div className="service-one__item__icon">
                        <img src={Batuk} alt="careox" height={50} width={50} />
                      </div>
                      <h3
                        className="service-one__item__title"
                        style={{ textAlign: "center" }}
                      >
                        {item?.howItWorksTitle}
                      </h3>
                      <p
                        className="service-one__item__text flex-grow-1"
                        style={{ textAlign: "center", fontFamily: "Poppins" }}
                      >
                        {item?.howItWorksDesc}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Popular pujas */}

      {(servicename === "puja-booking" ||
        servicename === "daily-puja-booking") && (
          <section
            className="service-one"
            style={{ padding: "30px 0", background: "white" }}
          >
            <div className="container">
              <div className="row gutter-y-30 d-flex align-center justify-center">
                <div className="col-12">
                  <div
                    className="sec-title text-center"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <h6
                      className="sec-title__tagline bw-split-in-right"
                      style={{ color: "#A52444" }}
                    >
                      <img className=" tagline-img" src={batuk} alt="" />
                      {servicename === "daily-puja-booking"
                        ? "Popular Daily Pujas"
                        : "Popular Pujas"}
                    </h6>

                    <h3 className="sec-title__title bw-split-in-left">
                      Sacred rituals trusted by devotees worldwide.
                    </h3>

                    {/* <h6
                    className="bw-split-in-right"
                    style={{
                      width: "70vw",
                      marginTop: "20px",
                      textAlign: "justify",
                    }}
                  >
                    Explore our most booked pujas! Find peace and prosperity
                    with these powerful ceremonies chosen by devotees like you.
                    Book now!
                  </h6> */}
                  </div>
                  <div
                    className="col-12"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "25px",
                    }}
                  >
                    {servicename === "puja-booking"
                      ? pujaListData?.slice(0, 4).map((item, index) => (
                        <Link
                          to={`/services/book-puja/${item?.PujaSlug}`}
                          state={{ product: item }}
                        >
                          <div
                            key={index}
                            className="col-lg-3 col-md-6 col-sm-6 product-item-one"
                            style={{
                              marginBottom: "15px",
                              width: "12em",
                              height: "340px",
                            }}
                          >
                            <div
                              className="card card-shadow-sty shadow-sm bg-white rounded p-2 w-100 d-flex h-100"
                              style={{ cursor: "pointer" }}
                            >
                              <div className="product-image text-center position-relative">
                                <img
                                  src={item?.PUJA_IMAGE || placeholderImg}
                                  className="img-fluid rounded w-100"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = placeholderImg;
                                  }}
                                  style={{
                                    objectFit: "contain",
                                    height: "180px",
                                  }}
                                />
                              </div>
                              <div
                                className="product-details text-center d-flex align-item-center justify-content-center flex-column flex-grow-1 p-2"
                                style={{ margin: "0" }}
                              >
                                <h6
                                  style={{
                                    fontSize: "18px",
                                    color: "#8f3246",
                                    fontWeight: "600",
                                  }}
                                >
                                  {item.PUJA_NAME}
                                </h6>
                                <div className="prod-details d-flex align-items-center flex-column">
                                  <span
                                    style={{
                                      fontSize: "16px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    ₹ {item.PUJA_PRICE}
                                  </span>
                                  <span
                                    style={{
                                      whiteSpace: "nowrap",
                                      color: "#a52444",
                                      fontSize: "15px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: "5px",
                                    }}
                                  >
                                    View Details{" "}
                                    <i className="icon-right-arrow"></i>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>{" "}
                        </Link>
                      ))
                      : servicename === "daily-puja-booking"
                        ? pujaDailyListData?.slice(0, 4).map((item, index) => (
                          <Link
                            to={`/services/daily-booking/puja-details/${item?.DailyPujaSlug}`}
                            state={{ product: item }}
                          >
                            <div
                              key={index}
                              className="col-lg-3 col-md-6 col-sm-6 product-item-one"
                              style={{
                                marginBottom: "15px",
                                width: "12em",
                                height: "340px",
                              }}
                            >
                              <div
                                className="card card-shadow-sty shadow-sm bg-white rounded p-2 w-100 d-flex h-100"
                                style={{ cursor: "pointer" }}
                              >
                                <div className="product-image text-center position-relative">
                                  <img
                                    src={placeholderImg}
                                    className="img-fluid rounded w-100"
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = placeholderImg;
                                    }}
                                    style={{
                                      objectFit: "contain",
                                      height: "180px",
                                    }}
                                  />
                                </div>
                                <div
                                  className="product-details text-center d-flex align-item-center justify-content-center flex-column flex-grow-1 p-2"
                                  style={{ margin: "0" }}
                                >
                                  <h6
                                    style={{
                                      fontSize: "18px",
                                      color: "#8f3246",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {item.DP_NAME}
                                  </h6>
                                  <div className="prod-details d-flex align-items-center flex-column">
                                    <span
                                      style={{
                                        fontSize: "16px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      ₹ {item.DP_PRICE}
                                    </span>
                                    <span
                                      style={{
                                        whiteSpace: "nowrap",
                                        color: "#a52444",
                                        fontSize: "15px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "5px",
                                      }}
                                    >
                                      View Details{" "}
                                      <i className="icon-right-arrow"></i>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>{" "}
                          </Link>
                        ))
                        : ""}
                    {/* {pujaListData?.slice(0, 4).map((item, index) => (
                  <Link
                    to={`/services/book-puja/${item?.PUJA_NAME.split(" ")
                      .join("-")
                      .toLowerCase()}`}
                    state={{ product: item }}
                  >
                    <div
                      key={index}
                      className="col-lg-3 col-md-6 col-sm-6 product-item-one"
                      style={{
                        marginBottom: "15px",
                        width: "12em",
                        height: "340px",
                      }}
                    >
                      <div
                        className="card card-shadow-sty shadow-sm bg-white rounded p-2 w-100 d-flex h-100"
                        style={{ cursor: "pointer" }}
                      >
                        <div className="product-image text-center position-relative">
                          <img
                            src={placeholderImg}
                            className="img-fluid rounded w-100"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = placeholderImg;
                            }}
                            style={{ objectFit: "cover", height: "180px" }}
                          />
                        </div>
                        <div
                          className="product-details text-center d-flex align-item-center justify-content-center flex-column flex-grow-1 p-2"
                          style={{ margin: "0" }}
                        >
                          <h6
                            style={{
                              fontSize: "18px",
                              color: "#8f3246",
                              fontWeight: "600",
                            }}
                          >
                            {item.PUJA_NAME}
                          </h6>
                          <div className="prod-details d-flex align-items-center flex-column">
                            <span
                              style={{ fontSize: "16px", whiteSpace: "nowrap" }}
                            >
                              ₹ {item.PUJA_PRICE}
                            </span>
                            <span
                              style={{
                                whiteSpace: "nowrap",
                                color: "#a52444",
                                fontSize: "15px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "5px",
                              }}
                            >
                              View Details <i className="icon-right-arrow"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>{" "}
                  </Link>
                ))} */}
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      {/* Why choose us */}

      <section
        className="py-5 text-center"
        style={{ backgroundColor: "#f1f6f7" }}
      >
        <div
          className="container"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <h6
            className="sec-title__tagline bw-split-in-right"
            style={{ color: "#A52444" }}
          >
            <img className=" tagline-img" src={batuk} alt="" />
            Why Choose Us
          </h6>

          <h3 className="sec-title__title bw-split-in-left">
            Myomnamo offers easy, authentic puja services trusted by thousands
            of devotees.
          </h3>

          <div
            className="d-flex flex-wrap justify-content-center"
            style={{
              gap: "30px", // Increase this value for more space
              padding: "20px",
            }}
          >
            {selectedReasons.map((reason, index) => (
              <div
                key={index}
                className="card shadow-sm border-0 p-4 text-center"
                style={{
                  width: "320px", // Adjust width as needed
                  minHeight: "300px", // Optional: for uniform height
                }}
              >
                <div className="mb-3">{reason.icon}</div>
                <h5 className="fw-bold mb-2">{reason.title}</h5>
                <p style={{ textAlign: "justify" }}>{reason.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section
        className="d-flex align-items-center"
        style={{
          backgroundImage: `url(${bg}) no-repeat center center`,

          backgroundSize: "cover",
          backgroundColor: "#E7E0E0",
          minHeight: "230px",
        }}
      >
        <div className="container">
          <div
            className="row align-items-center justify-content-center text-center text-lg-center"
            style={{ padding: "20px 0px" }}
          >
            {/* <!-- Left Content --> */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <h2
                className="fw-bold text-dark mb-4"
                style={{ color: "#791818", textAlign: "center" }}
              >
                Download Myomnamo app now !!
              </h2>
              <div className="d-flex justify-content-center justify-content-lg-center align-items-center">
                <a
                  href="https://play.google.com/store/apps/details?id=spiritualapp.myomnamo"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="me-3"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                    alt="Google Play"
                    height="50"
                  />
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setShowComingSoonModal(true)}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                    alt="App Store"
                    height="50"
                  />
                </a>
              </div>
            </div>
            {/* <!-- Right Image --> */}
            <div
              className="col-lg-6 text-center"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={AppImg}
                alt="App with Pandit Character"
                width={200}
                height={200}
                className="img-fluid"
                style={{ maxHeight: "320px" }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Become a parter */}
      <Support />


      {/* Testimonials */}

      <section
        className="testimonials-page"
        style={{ backgroundColor: "white" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="sec-title text-center">
                <h6
                  className="sec-title__tagline bw-split-in-right"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img className=" tagline-img" src={batuk} alt="" />
                  Testimonials
                </h6>
                <h3
                  className="sec-title__title bw-split-in-left"
                  style={{ textAlign: "center" }}
                >
                  Devotee Testimonials
                </h3>
              </div>
              <OwlCarousel
                className="testimonials-page__carousel careox-owl__carousel careox-owl__carousel--with-shadow careox-owl__carousel--basic-nav owl-carousel owl-theme"
                {...owlOptions}
              >
                {serviceData.testimonials.map((testimonial, index) => (
                  <div
                    className="item"
                    key={index}
                  // style={{ backgroundColor: "white" }}
                  >
                    <div
                      className="testimonials-page__card"
                      style={{
                        color: "#a42642",
                        height: "298px",
                        // backgroundColor: "white",
                      }}
                    >
                      {/* <div className="testimonials-page__card__image">
                        <img src={testimonial.image} alt={testimonial.name} />
                      </div> */}
                      <div className="testimonials-page__card__rating">
                        {[...Array(5)].map((_, i) => (
                          <i key={i} className="icofont-star"></i>
                        ))}
                      </div>
                      <div className="testimonials-page__card__content">
                        {testimonial.Desc}
                      </div>
                      <h3 className="testimonials-page__card__name">
                        {testimonial.name}
                      </h3>
                      <p className="testimonials-page__card__designation">
                        {testimonial.location}
                      </p>
                      <div className="testimonials-page__card__quote">
                        <i className="icofont-quote-left"></i>
                      </div>
                    </div>
                  </div>
                ))}
              </OwlCarousel>
            </div>
          </div>
        </div>
      </section>

      {/* <FAQSection /> */}

      <section className="faq-one faq-one--page">
        <div
          className="container"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <div className="sec-title text-center">
            <h6
              className="sec-title__tagline bw-split-in-right"
              style={{
                perspective: "400px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* <img className=" tagline-img" src={batuk} alt="" /> FAQ */}
              <img className=" tagline-img" src={batuk} alt="" /> FAQ
              {/* <span className="sec-title__tagline__border"></span> FAQ */}
            </h6>
            <h3
              className="sec-title__title bw-split-in-left"
              style={{ perspective: "400px", textAlign: "center" }}
            >
              Frequently Asked Questions.
            </h3>
          </div>
          <div className="row">
            <div className="col-xl-2"></div>
            <div className="col-xl-8">
              <div className="faq-one__accordion careox-accordion">
                {serviceData.FaqObj.map((faq, index) => (
                  <div
                    key={index}
                    className={`accrodion ${activeIndex === index ? "active" : ""
                      }`}
                    style={{ "--accent-color": faq.color }}
                  >
                    <div
                      className="accrodion-title"
                      onClick={() => toggleFAQ(index)}
                    >
                      <h4>
                        <span
                          className="accrodion-title__number"
                          style={{ marginRight: "10px", fontWeight: "500" }}
                        ></span>
                        {faq.question}
                        <span className="accrodion-title__icon"></span>
                      </h4>
                    </div>
                    <div
                      className="accrodion-content"
                      style={{
                        maxHeight: activeIndex === index ? "200px" : "0",
                        overflow: "hidden",
                        transition: "max-height 0.5s ease-in-out",
                      }}
                    >
                      <div className="inner">
                        <p>{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-xl-2"></div>

            <ExitIntentModal
              slug={slug}
              show={showExitIntentModal}
              onHide={() => {
                setShowExitIntentModal(false);
              }}
            />
          </div>
        </div>
      </section>
      <BlogCarousel />
      <ComingSoonModal
        show={showComingsoonModal}
        onClose={() => setShowComingSoonModal(false)}
      />
    </div>
  );
};

export default ServicesLandingPage;
